import React from 'react';

import styled from 'styled-components';

const AssetWrapper = styled.div`
  position: absolute;
  z-index: 1;
  font-size: 10px;
  padding: 10px;
  text-transform: uppercase;
  font-weight: 700;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: ${({ theme: { colors } }) => `${colors.white}`};
  background: rgba(192, 57, 43, 0.3);
`;

function GridGuideAsset() {
  return <AssetWrapper />;
}

export default GridGuideAsset;
